import React, { useEffect } from 'react';

import { connectTo } from '../../utils/generic';
import * as actions from '../../actions/announcements';
import { useShowNotification } from '@/shared/components/Notifications';

const Notification = ({ message, options }) => {
  const showNotification = useShowNotification();

  useEffect(() => {
    if (!message) return;
    const { text, type } = message;
    showNotification(text, type, options);
  }, [message]);

  return <React.Fragment></React.Fragment>;
};

export default connectTo(
  (state) => {
    return {
      ...state.notification,
    };
  },
  actions,
  Notification
);
